
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSnowShowersPolartwilightColour as ObiSnowShowersPolartwilightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-snow-showers-polartwilight-colour.js';
 
 
 

 
 export const ObiSnowShowersPolartwilightColour = createComponent({
   react: React,
   tagName: 'obi-snow-showers-polartwilight-colour',
   elementClass: ObiSnowShowersPolartwilightColourElement,
   events: {
     
   }
  });
 
 